// SVG icons as URLs (add ?url to force URL import with vite-plugin-svgr)
import adminIcon from './icons/admin.svg?url'
import brandIcon from './icons/brand.svg?url'
import categoriesIcon from './icons/categories.svg?url'
import certifIcon from './icons/certif.svg?url'
import continentsIcon from './icons/continents.svg?url'
import darkIcon from './icons/dark.svg?url'
import homeIcon from './icons/home.svg?url'
import ingredientIcon from './icons/ingredient.svg?url'
import lightIcon from './icons/light.svg?url'
import lockIcon from './icons/lock.svg?url'
import logoutIcon from './icons/logout.svg?url'
import mailIcon from './icons/mail.svg?url'
import messageIcon from './icons/message.svg?url'
import productIcon from './icons/product.svg?url'
import settingsIcon from './icons/settings.svg?url'
import usersIcon from './icons/users.svg?url'
import warningIcon from './icons/warning.svg?url'

// Images
import logo from './images/logo.png'
import logoMini from './images/logo_mini.png'

export const icons = {
  admin: adminIcon,
  brand: brandIcon,
  categories: categoriesIcon,
  certif: certifIcon,
  continents: continentsIcon,
  dark: darkIcon,
  home: homeIcon,
  ingredient: ingredientIcon,
  light: lightIcon,
  lock: lockIcon,
  logout: logoutIcon,
  mail: mailIcon,
  message: messageIcon,
  product: productIcon,
  settings: settingsIcon,
  users: usersIcon,
  warning: warningIcon,
} as const

export const images = {
  logo,
  logoMini,
} as const

// Type helpers
export type IconName = keyof typeof icons
export type ImageName = keyof typeof images

// Helper function to get icon URL
export const getIcon = (name: IconName): string => icons[name]
export const getImage = (name: ImageName): string => images[name]